export const documentSampleTags = [
    {
        type: 'id',
        name: 'risk/doc/upload_requirement',
        values: ['optional', 'disabled', 'mandatory'],
        statusTag: 'risk/doc/status',
        documents: [
            { label: 'selectDocument', value: '' },
            { label: 'passport', value: 'PASSPORT' },
            { label: 'idCard', value: 'ID_CARD' },
            { label: 'drivingLicense', value: 'DRIVING_LICENSE' },
            { label: 'residencePermit', value: 'chpermit' },
            { label: 'luganoClassCard', value: 'lgnclass' }
        ]
    },
    {
        type: 'address',
        name: 'risk/doc/upload_requirement_additional',
        values: ['optional', 'disabled', 'pending', 'mandatory'],
        statusTag: 'risk/doc/status_additional',
        documents: [
            { label: 'selectDocument', value: '' },
            { label: 'utilityBill', value: 'UB' }
        ]
    },
    {
        type: 'additional',
        name: 'risk/doc/additional_verification',
        values: ['not_required', 'required', 'pending', 'approved', 'failed'],
        statusTag: 'risk/doc/additional_verification',
        documents: [
            { label: 'selectDocument', value: '' },
            { label: 'other', value: 'Other1' }
        ]
    }
];
